import PoweredByStripe from "common/components/PoweredByStripe";
import PrimaryPaymentSource from "common/components/PrimaryPaymentSource";
import type { PaymentSource } from "common/types";

import type { ReactNode } from "react";

interface SummaryProps {
  selectedPaymentSource: PaymentSource;
  onChangePaymentSource: () => void;
  children: ReactNode;
}

export default function Summary({
  selectedPaymentSource,
  onChangePaymentSource,
  children,
}: SummaryProps) {
  return (
    <>
      <div className="flex flex-col gap-y-6 rounded-4xl bg-black-50 p-2">
        <PrimaryPaymentSource
          isLoading={false}
          paymentSource={selectedPaymentSource}
          onEdit={onChangePaymentSource}
        />
        <div className="flex flex-col gap-y-2.5">{children}</div>
      </div>
      <PoweredByStripe />
    </>
  );
}
